/**
 * Identifiant pour les aides contextuel
 */
export const CONTEXT_HELP_HOME_REALTIME = 'accueil-temps-reel';
export const CONTEXT_HELP_BOOKING_DATED_TRIP = 'reserver-deplacement-occasionnel';
export const CONTEXT_HELP_BOOKING_TEMPLATE_TRIP = 'reserver-deplacement-regulier';

export const CONTEXT_HELP_BOOKING_TYPE = 'reserver-type-deplacement';
export const CONTEXT_HELP_BOOKING_TYPE_REGULAR = 'reserver-type-deplacement-regulier';
export const CONTEXT_HELP_BOOKING_DATE = 'reserver-date-deplacement';
export const CONTEXT_HELP_BOOKING_ADDRESS_TYPE = 'reserver-adresse-selection';
export const CONTEXT_HELP_BOOKING_ADDRESS_SEARCH = 'reserver-adresse-recherche';
export const CONTEXT_HELP_BOOKING_ADDRESS_RESTRICTED = 'reserver-adresse-type-restreint';
export const CONTEXT_HELP_BOOKING_ADDRESS_DRIVER_NOTE = 'reserver-adresse-indication-chauffeur';
export const CONTEXT_HELP_BOOKING_TIME = 'reserver-heure';
export const CONTEXT_HELP_BOOKING_DEVICES_OUTWARD = 'reserver-aide-mobilite-aller';
export const CONTEXT_HELP_BOOKING_DEVICES_INWARD = 'reserver-aide-mobilite-retour';
export const CONTEXT_HELP_BOOKING_COMPANIONS_INWARD = 'reserver-accompagnement-retour';
export const CONTEXT_HELP_BOOKING_TEMPLATE_DAYS = 'reserver-regulier-jours';
export const CONTEXT_HELP_BOOKING_TEMPLATE_START_DATE = 'reserver-regulier-date-debut';
export const CONTEXT_HELP_BOOKING_ADDRESS_DIALYSIS = 'reserver-adresse-dialyse';
export const CONTEXT_HELP_TRACK_MY_VEHICLE = 'suivre-vehicule';
export const CONTEXT_HELP_CHANGE_INFO_NOTIFICATIONS = 'modifier-infos-notifications';
export const CONTEXT_HELP_BOOKING_PROBLEM_TIME = 'reserver-soumission-erreur-heure-non-realisable';

export const CONTEXT_HELP_SERVICE_REQUESTS_LIST = 'gerer-deplacements';
export const CONTEXT_HELP_SERVICE_REQUESTS_PAYMENT = 'tarif';
